/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Remove_List_ConfirmInputs */

const en_markers_remove_list_confirm = /** @type {(inputs: Markers_Remove_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure?`)
};

const fr_markers_remove_list_confirm = /** @type {(inputs: Markers_Remove_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer ?`)
};

const de_markers_remove_list_confirm = /** @type {(inputs: Markers_Remove_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bist du sicher?`)
};

const it_markers_remove_list_confirm = /** @type {(inputs: Markers_Remove_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro?`)
};

const ru_markers_remove_list_confirm = /** @type {(inputs: Markers_Remove_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены?`)
};

const es_markers_remove_list_confirm = /** @type {(inputs: Markers_Remove_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Está seguro?`)
};

const zh_cn2_markers_remove_list_confirm = /** @type {(inputs: Markers_Remove_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你确定吗？`)
};

const ja_markers_remove_list_confirm = /** @type {(inputs: Markers_Remove_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本気ですか？`)
};

const hi_markers_remove_list_confirm = /** @type {(inputs: Markers_Remove_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आपको यकीन है?`)
};

const pt_pt2_markers_remove_list_confirm = /** @type {(inputs: Markers_Remove_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza?`)
};

/**
* | output |
* | --- |
* | "Are you sure?" |
*
* @param {Markers_Remove_List_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_remove_list_confirm = /** @type {((inputs?: Markers_Remove_List_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Remove_List_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_remove_list_confirm(inputs)
	if (locale === "de") return de_markers_remove_list_confirm(inputs)
	if (locale === "it") return it_markers_remove_list_confirm(inputs)
	if (locale === "ru") return ru_markers_remove_list_confirm(inputs)
	if (locale === "es") return es_markers_remove_list_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_remove_list_confirm(inputs)
	if (locale === "ja") return ja_markers_remove_list_confirm(inputs)
	if (locale === "hi") return hi_markers_remove_list_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_remove_list_confirm(inputs)
	return en_markers_remove_list_confirm(inputs)
});